import React, { FC } from 'react'

import { Text } from '@interco/inter-ui/components/Text'

import { ResponseContainer, TextContainer } from '../styles/ServiceResponse.styles'

export const ServiceResponseView: FC<{
  response: string
  aditionalInfo: string
}> = ({ response, aditionalInfo }) => (
  <ResponseContainer data-testid="service-response-view">
    {response && (
      <TextContainer data-testid="service-response-text">
        <Text variant="body-3" colorWeight={400}>
          {response}
        </Text>
      </TextContainer>
    )}
    {aditionalInfo && (
      <TextContainer data-testid="service-response-additional-info">
        <Text variant={response ? 'caption-1' : 'body-3'} colorWeight={400}>
          {aditionalInfo}
        </Text>
      </TextContainer>
    )}
  </ResponseContainer>
)
